export const LOGIN = '/login-plcp'
export const HOME = '/home-plcp'
export const PLPRIMARYSTARS = '/pl-primary-stars'
export const PLKICKS = '/pl-kicks'
export const PLINSPIRES = '/pl-inspires'
export const PLPFA = '/pl-pfa'
export const FACILITIES = '/facilities'
export const FUNDING = '/funding'
export const ECONOMIC_IMPACT = '/economic-impact'
export const EXPORT = '/export'
// export const ABOUTTHEPL = '/about-the-pl'

export const HOME_MP = '/mp/home-plcp'
export const PLPRIMARYSTARS_MP = '/mp/pl-primary-stars'
export const PLKICKS_MP = '/mp/pl-kicks'
export const PLINSPIRES_MP = '/mp/pl-inspires'
export const PLPFA_MP = '/mp/pl-pfa'
export const FACILITIES_MP = '/mp/facilities'
export const FUNDING_MP = '/mp/funding'
export const ECONOMIC_IMPACT_MP = '/mp/economic-impact'
export const EXPORT_MP = '/mp/export'
